<!-- //
可视化组件的标题
@auth xuyd
@date 2024-05-05
//-->
<template>
  <div class="editor-component-title">
    <div class="component-title-top">
      <span :title="versionProps.title">{{ versionProps.title }}</span>
      <el-tooltip popper-class="dv-tooltip" content="查看组件文档" placement="right">
        <i class="el-icon-document component-name-help" @click="handleHelp"/>
      </el-tooltip>
    </div>
    <div class="component-info">
      <div class="component-version">
        v{{ versionProps.version || "1.0.0" }} | {{ versionProps.title }}
      </div>
      <div v-if="versionProps.upgrade" class="component-upgrade" @click="handleUpgrade">更新</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WidgetVersion',
  data() {
    return {}
  },
  props: {
    versionProps: {
      type: Object,
      default: () => {
        return {
          title: null,
          version: null
        }
      }
    }
  },
  watch: {
    versionProps: {
      handler: function (val) {
        console.log(`---------watch ${this.$options._componentTag} versionProps-------->`);
        this.versionProps = val;
      },
      immediate: true
    }
  },
  methods: {
    handleHelp(versionProps) {
      window.open(versionProps.docUrl + '?widgetNum=' + versionProps.widgetNum + '&version=' + versionProps.version, '_blank');
    },
    handleUpgrade(versionProps) {
      // TODO 更新版本，默认从仓库推到当前用户创建的namespace中
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/variables.less';

.editor-component-title {
  width: 100%;
  padding: 0 0 5px 0;
  position: relative;
  user-select: none;
  color: @dv_form_label_color;

  .component-title-top {
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.4px;
    display: flex;
    overflow: hidden;
    align-items: center;

    .component-name-help {
      margin: 10px;
      cursor: pointer;
    }
  }

  .component-info {
    margin-top: 4px;
    font-size: 12px;
    display: flex;
    align-items: center;

    .component-upgrade {
      color: @dv_form_link_color;
      cursor: pointer;
      margin-left: 10px;
    }
  }
}
</style>
